import { render, staticRenderFns } from "./DisposalDetailsView.vue?vue&type=template&id=8023fe40"
import script from "./DisposalDetailsView.vue?vue&type=script&lang=js"
export * from "./DisposalDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports